import { Icon } from "source/shared/components"

export function OrganizationNotAcceptingDonations() {
  return (
    <div className="ta-c c-tint2 fs-2">
      <div className="mb-1">
        <Icon symbol="churchCenter#giving-o" />
      </div>
      We&apos;re not quite ready for online donations yet.
    </div>
  )
}
